import type { AccountAanmakenInput, AuthUser, LoginInput, UitnodigingCheck } from '@fleet/shared';
import { api } from '../../lib/apiClient';

export const authApi = {
  me: () => api.get<{ user: AuthUser | null }>('/auth/me'),
  login: (input: LoginInput) => api.post<{ user: AuthUser }>('/auth/login', input),
  logout: () => api.post<{ ok: true }>('/auth/logout'),

  /** Publiek: hoort bij de uitnodigingslink uit de mail. Een 410 betekent dat de
   *  link verlopen, al gebruikt of onbekend is. */
  checkUitnodiging: (token: string) =>
    api.get<UitnodigingCheck>(`/auth/uitnodiging/${encodeURIComponent(token)}`),
  maakAccount: (token: string, input: AccountAanmakenInput) =>
    api.post<{ user: AuthUser }>(`/auth/uitnodiging/${encodeURIComponent(token)}`, input),
};
